import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ChevronIcon = styled.svg.attrs({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "currentColor",
    viewBox: "0 0 16 16"
})`
  transition: transform 0.2s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

const AccordionItem = ({ title, children, isOpen, onToggle }) => (
    <div className="border-bottom">
        <button
            className="btn btn-link text-dark text-decoration-none w-100 text-start p-3"
            onClick={onToggle}
            aria-expanded={isOpen}
        >
            <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fw-bold" style={{ fontSize: '1rem' }}>{title}</h5>
                <ChevronIcon isOpen={isOpen}>
                    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                </ChevronIcon>
            </div>
        </button>
        {isOpen && (
            <div className="p-3 pt-0">
                <div className="card-body bg-light rounded-3 p-3">
                    {children}
                </div>
            </div>
        )}
    </div>
);

const TopInformation = () => {
    const [open, setOpen] = useState({
        important: true,
        handbook: false,
        mail: false,
        average: false,
        teiin: true,
    });

    const toggle = (id) => {
        setOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const url = '/toitu/';
    const registerMailUrl = 'https://toitumosi.jp/join/registmail.html';

    return (
        <div className="container my-4">
            <div className="card shadow-sm border-0 border-top border-5 border-success rounded-4 overflow-hidden">
                <div className="row g-0">
                    <div className="col-md-3 d-flex align-items-center justify-content-center text-white" style={{ backgroundColor: '#009d80', minHeight: '150px' }}>
                        <h3 className="fw-bold">お知らせ</h3>
                    </div>
                    <div className="col-md-9">
                        <div className="card-body p-0">
                            <AccordionItem
                                title="受験者および保護者のみなさまへ"
                                isOpen={open.important}
                                onToggle={() => toggle('important')}
                            >
                                <p className="mb-2">体調がすぐれない時は、受験を控えてください</p>
                                <p className="fw-bold mb-1">模試返送について</p>
                                <ul className="ps-3 mb-2">
                                    <li>土・日は配達が行われません。</li>
                                    <li>木曜日に郵便局に持ち込み後、郵送に2日かかります。よって月曜日以降の到着となります。ご了承ください。</li>
                                </ul>
                                <p className="mb-0">今年の室戸会場は第３回～の実施になります</p>
                            </AccordionItem>

                            <AccordionItem
                                title="-　統一模試活用法　-"
                                isOpen={open.handbook}
                                onToggle={() => toggle('handbook')}
                            >
                                <ol className="ps-3 mb-0">
                                    <li>問題用紙を必ず封筒（白色）に入れて持ち帰りください</li>
                                    <li>解答・解説は実施日の翌日の夕方以降に掲載いたします</li>
                                    <li>試験実施後、1週間後にHPにて確認できるもの<br />
                                    　偏差値による判定基準：過去の入試データと比較して、学校ごとの合格可能性を偏差値で判定　</li>
                                    <li>マイページに登録しよう</li>
                                </ol>
                            </AccordionItem>

                            <AccordionItem
                                title="統一お知らせメール"
                                isOpen={open.mail}
                                onToggle={() => toggle('mail')}
                            >
                                <ul className="ps-3 mb-2">
                                    <li>次回以降の試験結果の登録や高校入試に関わる情報をお知らせいたします。</li>
                                    <li>※予約受付け開始時にお知らせメールが届きます。</li>
                                </ul>
                                <a href={registerMailUrl} target="_blank" rel="noopener noreferrer" className="text-success fw-bold">
                                    お知らせメールの登録はこちら
                                </a>
                            </AccordionItem>

                            <AccordionItem
                                title="高知県公立高校入試各教科平均点"
                                isOpen={open.average}
                                onToggle={() => toggle('average')}
                            >
                                <p>令和7年度 高知県公立高校入試 各教科平均点（50点満点）</p>
                                <table className="table table-bordered text-center small">
                                    <thead className="table-light">
                                        <tr><th>教科</th><th>令和7年度</th><th>令和6年度</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>国語</td><td>23.4</td><td>21.7</td></tr>
                                        <tr><td>社会</td><td>22.2</td><td>19.0</td></tr>
                                        <tr><td>数学</td><td>18.8</td><td>18.3</td></tr>
                                        <tr><td>理科</td><td>14.0</td><td>19.9</td></tr>
                                        <tr><td>英語</td><td>18.6</td><td>22.9</td></tr>
                                        <tr className="table-light"><td><strong>総合</strong></td><td><strong>97.0</strong></td><td><strong>101.6</strong></td></tr>
                                    </tbody>
                                </table>
                            </AccordionItem>

                            <AccordionItem
                                title="県教育委員会より定員減が発表されました。(2026/3/27)"
                                isOpen={open.teiin}
                                onToggle={() => toggle('teiin')}
                            >
                                <p className="mb-1">・定員削減</p>
                                <p className="mb-1">高知東高校　総合学科 40名</p>
                                <p className="mb-1">安芸高校　普通科 40名</p>
                                <p className="mb-1">・学科統合</p>
                                <p className="mb-1">東工業　統合により40名減</p>
                                <p className="mb-1">幡多農業　学科改編により40名減</p>
                                <p className="mb-1">須崎総合　学科改編により40名減</p>
                                <p className="mb-1">宿毛工業　学科改編により40名減</p>

                            </AccordionItem>

                            <div className="border-bottom">
                                <Link to={url + 'ForToNextYear'} className="btn btn-link text-dark text-decoration-none w-100 text-start p-3">
                                    <h5 className="mb-0 fw-bold" style={{ fontSize: '1rem' }}>「本番入試に向けて」を更新（2024/4/27）</h5>
                                </Link>
                            </div>

                            <div className="border-bottom-0">
                                <div className="p-3">
                                    <h5 className="mb-0 fw-bold" style={{ fontSize: '1rem' }}>ホームページリニューアルしました。(07/28)</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopInformation;
